import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

import { createBox } from '@shopify/restyle';

import { AppTheme } from '../theme';

export const TouchableBox = createBox<AppTheme, TouchableOpacityProps>(TouchableOpacity);

export type TouchableBoxProps = React.ComponentProps<typeof TouchableBox>;
